import * as React from 'react';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import FooterLogo from 'components/footer-logo';
import { IFooterLogoItem } from '../footer.types';
import '../footer.styles.less';

const LogosWrapper: React.FC<ILogosWrapperProps> = ({ items }) => (
    <div className="sitegen-footer__logos-wrapper">
        <div className="sitegen-footer__logos-container">
            {items.map((item, index) => (
                <FooterLogo
                    key={index}
                    className={item.className}
                    href={item.href}
                    onClick={() => {
                        AnalyticsService.sendFlowEvent({
                            location: 'footer',
                            category: CATEGORY.ACTION,
                            action: `go to ${item.analyticsAction.toLowerCase()}`
                        });
                    }}
                />
            ))}
        </div>
    </div>
);

export interface ILogosWrapperProps {
    items: IFooterLogoItem[];
}

export default LogosWrapper;
